import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminSalesContent from "../admin/components/AdminSalesContent";

const SupportOfficerSales = () => {
  return (
    <SupportLayout userRole="SO">
      <AdminSalesContent useOwnLayout={true} />
    </SupportLayout>
  );
};

export default SupportOfficerSales;
